/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AdditionalQuestionUpdatePathParams,
	AdditionalQuestionUpdateRequest,
	AdditionalQuestionUpdateResponse,
} from '../types/AdditionalQuestionUpdate'

/**
 * PATCH /additional-questions/:question
 * @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::update
 */
export async function additionalQuestionUpdate(
	question: AdditionalQuestionUpdatePathParams['question'],
	data: AdditionalQuestionUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdditionalQuestionUpdateResponse>> {
	return axiosInstance.patch(`/additional-questions/${question}`, data, config)
}
